<div class="min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-white font-sans relative">
  <!-- Global Top Progress Bar -->
  @if (isLoading()) {
    <div class="fixed top-0 left-0 right-0 z-50 h-1 bg-blue-600/30 overflow-hidden">
      <div class="h-full bg-blue-600 animate-pulse w-full"></div>
    </div>
  }

  <main role="main">
    <router-outlet></router-outlet>
  </main>

  <app-toast-container />
</div>